<template>
  <v-container
    class="fill-height"
  >
    <v-row
      justify="center"
      align="center"
      class="fill-height ma-0 mb-2"
    >
      <v-card
        width="100%"
        id="processing-step-basic-nm-processing"
      >
        <v-card-title>Nome do processamento</v-card-title>
        <v-divider/>
        <v-card-text>
          <v-text-field
            id="processing-name-input"
            label="Nome do processamento"
            v-model="currentProcessingBasicData.nmProcessing"
            :error-messages="nmProcessingErrors"
            :disabled="inputDisabled"
            outlined
          >
          </v-text-field>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row
      justify="center"
      align="center"
      class="fill-height ma-0 my-2"
    >
      <v-card
        width="100%"
        id="processing-step-basic-project"
      >
        <v-card-title>Pasta do processamento</v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row
            justify="start"
            align="center"
            class="fill-height ma-0"
          >
            <v-radio-group
              v-model="projectSelectionState"
            >
              <v-radio
                id="radio-no-project"
                color="error"
                :value="PROJECT_SELECTION_STATES.NONE"
                label="Sem pasta"
                :disabled="inputDisabled"
              >
              </v-radio>
              <v-radio
                id="radio-existing-project"
                color="purple"
                :value="PROJECT_SELECTION_STATES.EXISTING"
                label="Selecionar pasta existente"
                :disabled="inputDisabled"
              >
              </v-radio>
              <v-radio
                id="radio-new-project"
                color="green"
                :value="PROJECT_SELECTION_STATES.NEW_PROJECT"
                label="Nova pasta"
                :disabled="inputDisabled"
              >
              </v-radio>
            </v-radio-group>
          </v-row>
          <v-row
            v-if="projectSelectionIsExisting"
            justify="start"
            align="center"
            class="fill-height ma-0"
          >
            <v-select
              label="Pasta"
              v-model="currentProcessingBasicData.cdProject"
              :error-messages="cdProjectErrors"
              :items="this._projectList"
              item-text="nm_project"
              item-value="id_project"
              :disabled="inputDisabled"
              outlined
            >
            </v-select>
          </v-row>
          <v-row
            v-if="projectSelectionIsNew"
            justify="start"
            align="center"
            class="fill-height ma-0"
          >
            <v-text-field
              label="Nome da pasta"
              v-model="currentProcessingBasicData.nmProject"
              :error-messages="nmProjectErrors"
              :disabled="inputDisabled"
              outlined
            >
            </v-text-field>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <!-- <v-row
      justify="center"
      align="center"
      class="fill-height ma-0 my-2"
    >
      <v-card
        width="100%"
        id="processing-step-basic-image-type"
      >
        <v-card-title>Tipo de imagem</v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row
            justify="space-around"
            align="center"
            class="fill-height ma-0"
          >
            <image-select
              v-model="currentProcessingBasicData.abProcessingType"
              :value="PROCESSING_TYPES.FULL_PROCESSING"
              id="processing-type-full-processing"
              :path="droneImageryIcon"
              title="Imagens de drones"
              :disabled="processingTypeDisabled"
              :error-messages="abProcessingTypeErrors"
            >
            </image-select>
            <image-select
              v-model="currentProcessingBasicData.abProcessingType"
              :value="PROCESSING_TYPES.TILLING"
              id="processing-type-tilling"
              :path="orthomosaicIcon"
              title="Ortomosaico"
              :disabled="processingTypeDisabled"
              :error-messages="abProcessingTypeErrors"
            >
            </image-select>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row> -->
    <v-row
      align="center"
      justify="start"
      class="actions my-10"
    >
      <v-spacer/>
      <fragment
        v-if="mustShowEditButtons"
      >
        <fragment v-if="editMode">
          <!-- Botões para começar, salvar e cancelar a edição do mosaico -->
          <v-btn
            @click="cancelEditMode"
            :disabled="isUpdating"
            outlined
            color="error"
          >
            Cancelar Edição
          </v-btn>
          <v-btn
            @click="requestProcessingUpdate"
            :loading="isUpdating"
            outlined
            color="success"
          >
            Salvar Edição
          </v-btn>
        </fragment>
        <fragment v-else>
          <v-btn
            @click="startEditMode"
            :disabled="this._processingIsReadOnly"
            outlined
            color="accent"
          >
            Editar
          </v-btn>
        </fragment>
      </fragment>
      <fragment
        v-else
      >
        <v-btn
          v-if="!this._processingIsReadOnly"
          @click="cancelProcessingCreation"
          :disabled="isCreating"
          id="processing-step-basic-cancel-button"
          color="error"
        >
          Cancelar
        </v-btn>
      </fragment>
      <v-btn
        @click="onNextClick"
        :loading="isLoading || isCreating || isUpdating"
        id="processing-step-basic-next-button"
        color="primary"
      >
        Próximo
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
  import {validationMixin} from "vuelidate"
  import required from "vuelidate/src/validators/required"
  import maxLength from "vuelidate/src/validators/maxLength"
  import minLength from "vuelidate/src/validators/minLength"
  import {mapActions, mapGetters} from "vuex"
  import {
    CLEAN_PROCESSING,
    CREATE_PROCESSING,
    GET_ID_PROCESSING,
    GET_PROCESSING_DATA,
    GET_PROCESSING_IS_BASIC_EDITABLE,
    GET_PROCESSING_IS_CREATED,
    GET_PROCESSING_IS_CREATING,
    GET_PROCESSING_IS_PROCESSING_TYPE_EDITABLE,
    GET_PROCESSING_IS_READ_ONLY,
    SET_ID_PROCESSING,
    UPDATE_PROCESSING,
  } from "../../../store/modules/processing"
  import {
    PROCESSING_STEPS,
    PROCESSING_TYPES,
    PROJECT_SELECTIONS_STATES,
    TILLING_CREATE_DATA_DEFAULT,
  } from "../../../helpers/processings/constants"
  import {cloneDeep, isEmpty, isEqual} from "lodash/lang"
  import {CREATE_PROJECT, GET_PROJECT_LIST} from "../../../store/modules/project"
  import requiredIf from "vuelidate/src/validators/requiredIf"
  // import ImageSelect from "../../Helpers/Form/ImageSelect"
  import {DIALOG_TYPES, DialogOptions} from "../../../helpers/dialogs"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../../helpers/notify"
  import {ProcessingStepperEventBus} from "../../../helpers/processings/events"

  const ProcessingNextStep = Symbol.for("ProcessingNextStep")
  const ProcessingSetStep = Symbol.for("ProcessingSetStep")

  export default {
    // components: {ImageSelect},
    inject: {NextStep: ProcessingNextStep, SetStep: ProcessingSetStep},
    mixins: [validationMixin],
    name: "ProcessingBasic",
    data: () => ({
      isLoading: false,
      isCreating: false,
      isUpdating: false,
      editMode: false,

      currentProcessingBasicData: {
        nmProcessing: null,
        abProcessingType: PROCESSING_TYPES.FULL_PROCESSING,
        // abProcessingType: null,
        cdProject: null,
        nmProject: null,
      },

      lastProcessingBasicData: {
        nmProcessing: null,
        abProcessingType: null,
        cdProject: null,
        nmProject: null,
      },

      projectSelectionState: PROJECT_SELECTIONS_STATES.NONE,

      PROCESSING_TYPES: PROCESSING_TYPES,
      PROJECT_SELECTION_STATES: PROJECT_SELECTIONS_STATES,
    }),
    validations() {
      return {
        currentProcessingBasicData: {
          nmProcessing: {
            required,
            maxLength: maxLength(60),
            minLength: minLength(4),
          },
          cdProject: {
            required: requiredIf(() => isEqual(this.projectSelectionState, PROJECT_SELECTIONS_STATES.EXISTING)),
          },
          nmProject: {
            required: requiredIf(() => isEqual(this.projectSelectionState, PROJECT_SELECTIONS_STATES.NEW_PROJECT)),
            maxLength: maxLength(60),
            minLength: minLength(4),
          },
          abProcessingType: {
            required
          }
        },
      }
    },
    methods: {
      onNextClick() {
        if (this._processingIsCreated) {
          this.pushNextStep()
        } else {
          this.requestProcessingCreation()
        }
      },
      cancelProcessingCreation() {
        this.$dialog(new DialogOptions({
          title: "Tem certeza que deseja cancelar?",
          content: "Se você cancelar agora todos os dados do seu projeto serão perdidos",
          confirmText: "Cancelar",
          cancelText: "Voltar",
          type: DIALOG_TYPES.CONFIRM,
          onConfirm: () => {
            this.cleanProcessing()
            this.$router.push("/app/")
          },
        }))
      },

      // Modo de criação
      requestProcessingCreation() {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          const isTilling = isEqual(this.currentProcessingBasicData.abProcessingType, PROCESSING_TYPES.TILLING)
          if (isTilling && !this.$subsMng.subscriptionPlanConfig["bl_allow_tilling"]) {
            this.$dialog(new DialogOptions({
              width: "650px",
              type: DIALOG_TYPES.BUSINESS_ONLY,
              content: `No seu plano atual não está incluso processamento de <br/><b>Ortomosaico</b>.<br/>
              Assine o plano Business e tenha todas as funcionalidades.`
            }))
            return
          }

          if (this.projectSelectionIsNone) this.currentProcessingBasicData.cdProject = null
          if (this.projectSelectionIsNew) {
            const projectData = {
              nm_project: this.currentProcessingBasicData.nmProject,
            }
            this._createProject(projectData)
              .then((res) => {
                this.currentProcessingBasicData.cdProject = res.data.data["id_project"]
                if (this.processingTypeIsFP) {
                  this.createProcessingFP()
                } else {
                  this.createProcessingTilling()
                }
              })
          } else {
            if (this.processingTypeIsFP) {
              this.createProcessingFP()
            } else {
              this.createProcessingTilling()
            }
          }
        }
      },
      createProcessingFP() {
        this.isCreating = true
        this.$appMng.setTitle(this.currentProcessingBasicData.nmProcessing)
        let processingData = {
          nm_processing: this.currentProcessingBasicData.nmProcessing,
          ab_processing_type: this.currentProcessingBasicData.abProcessingType,
          bl_gcp: false,
          ...((typeof this.currentProcessingBasicData.cdProject == "number") && {cd_project: this.currentProcessingBasicData.cdProject}),
        }
        this._createProcessing(processingData)
          .then((res) => {
            this.setIdProcessing(res.data.data["id_processing"])
            this.pushNextStep()
          })
          .catch(() => {
            this.handleError()
          })
          .finally(() => {
            this.isCreating = false
          })
      },
      createProcessingTilling() {
        this.isCreating = true
        // Se for ortomosaico o processamento deve ser criado e o usuário deve ser redirecionado para o uploader
        this.$appMng.setTitle(this.currentProcessingBasicData.nmProcessing)
        let processingData = {
          ...TILLING_CREATE_DATA_DEFAULT,
          nm_processing: this.currentProcessingBasicData.nmProcessing,
          ...((typeof this.currentProcessingBasicData.cdProject == "number") && {cd_project: this.currentProcessingBasicData.cdProject}),
        }
        // Criação do processamento
        this._createProcessing(processingData)
          .then((res) => {
            this.setIdProcessing(res.data.data["id_processing"])
            this.pushNextStep()
          })
          .catch(() => {
            this.handleError()
          })
          .finally(() => {
            this.isCreating = false
          })
      },

      // Modo Update
      requestProcessingUpdate() {
        this.$v.$touch()

        if (!this.$v.$invalid) {
          const isTilling = isEqual(this.currentProcessingBasicData.abProcessingType, PROCESSING_TYPES.TILLING)
          if (isTilling && !this.$subsMng.subscriptionPlanConfig["bl_allow_tilling"]) {
            this.$dialog(new DialogOptions({
              width: "650px",
              type: DIALOG_TYPES.BUSINESS_ONLY,
              content: `No seu plano atual não está incluso processamento de <br/><b>Ortomosaico</b>.<br/>
              Assine o plano Business e tenha todas as funcionalidades.`
            }))
            return
          }
          if (this.projectSelectionIsNone) this.currentProcessingBasicData.cdProject = null

          if (this.projectSelectionIsNew) {
            const projectData = {
              nm_project: this.currentProcessingBasicData.nmProject,
            }
            this._createProject(projectData)
              .then((res) => {
                this.currentProcessingBasicData.cdProject = res.data.data["id_project"]
                if (this.processingTypeIsFP) {
                  this.updateProcessingFP()
                } else {
                  this.updateProcessingTilling()
                }
              })
          } else {
            if (this.processingTypeIsFP) {
              this.updateProcessingFP()
            } else {
              this.updateProcessingTilling()
            }
          }
        }
      },
      updateProcessingFP() {
        this.isUpdating = true
        let processingData = {
          nm_processing: this.currentProcessingBasicData.nmProcessing,
          ab_processing_type: this.currentProcessingBasicData.abProcessingType,
          ...((typeof this.currentProcessingBasicData.cdProject == "number") && {cd_project: this.currentProcessingBasicData.cdProject}),
        }
        this._updateProcessing({
            idProcessing: this._idProcessing,
            processingData: processingData,
          })
          .then(() => {
            this.$appMng.setTitle(this.currentProcessingBasicData.nmProcessing)
            this.editMode = false
            this.pushNextStep()
          })
          .catch(() => {
            this.handleError()
          })
          .finally(() => {
            this.isUpdating = false
          })
      },
      updateProcessingTilling() {
        this.isUpdating = true
        // Se for ortomosaico o processamento deve ser criado e o usuário deve ser redirecionado para o uploader
        let processingData = {
          ...TILLING_CREATE_DATA_DEFAULT,
          nm_processing: this.currentProcessingBasicData.nmProcessing,
          ...((typeof this.currentProcessingBasicData.cdProject == "number") && {cd_project: this.currentProcessingBasicData.cdProject}),
        }
        // Criação do processamento
        this._updateProcessing({
            idProcessing: this._idProcessing,
            processingData: processingData,
          })
          .then(() => {
            this.$appMng.setTitle(this.currentProcessingBasicData.nmProcessing)
            this.editMode = false
            this.pushNextStep()
          })
          .catch(() => {
            this.handleError()
          })
          .finally(() => {
            this.isUpdating = false
          })
      },

      startEditMode() {
        this.editMode = true
        this.lastProcessingBasicData = cloneDeep(this.currentProcessingBasicData)
      },
      cancelEditMode() {
        this.editMode = false
        this.currentProcessingBasicData = this.lastProcessingBasicData
      },
      pushNextStep() {
        if (this.processingTypeIsFP) {
          this.SetStep(PROCESSING_STEPS.ADVANCED)
        } else {
          this.SetStep(PROCESSING_STEPS.UPLOAD)
        }
      },
      handleError() {
        this.isLoading = false
        this.$notify(new NotificationOptions({
          message: "Um erro inesperado ocorreu, por favor tente novamente mais tarde.",
          type: NOTIFICATION_TYPES.ERROR,
        }))
      },
      onStepEnter(step) {
        if (!isEqual(step, PROCESSING_STEPS.BASIC)) return
        if (!isEmpty(this._processingData)) {
          this.currentProcessingBasicData.nmProcessing = this._processingData["nm_processing"]
          this.currentProcessingBasicData.abProcessingType = this._processingData["ab_processing_type"]
          if (this._processingData["cd_project"]) {
            this.currentProcessingBasicData.cdProject = this._processingData["cd_project"]
            this.projectSelectionState = PROJECT_SELECTIONS_STATES.EXISTING
          }
        }
      },
      ...mapActions({
        setIdProcessing: SET_ID_PROCESSING,
        _createProject: CREATE_PROJECT,
        _createProcessing: CREATE_PROCESSING,
        _updateProcessing: UPDATE_PROCESSING,
        cleanProcessing: CLEAN_PROCESSING,
      }),
    },
    computed: {
      nmProcessingErrors() {
        const errors = []
        if (!this.$v.currentProcessingBasicData.nmProcessing.$dirty) return errors
        !this.$v.currentProcessingBasicData.nmProcessing.required && errors.push("Esse campo é obrigatório")
        !this.$v.currentProcessingBasicData.nmProcessing.minLength && errors.push("O nome do processamento precisa ter no minimo 4 caracteres")
        !this.$v.currentProcessingBasicData.nmProcessing.maxLength && errors.push("O nome do processamento pode ter no máximo 60 caracteres")
        return errors
      },
      cdProjectErrors() {
        const errors = []
        if (!this.$v.currentProcessingBasicData.cdProject.$dirty) return errors
        !this.$v.currentProcessingBasicData.cdProject.required && errors.push("Esse campo é obrigatório")
        return errors
      },
      nmProjectErrors() {
        const errors = []
        if (!this.$v.currentProcessingBasicData.nmProject.$dirty) return errors
        !this.$v.currentProcessingBasicData.nmProject.required && errors.push("Esse campo é obrigatório")
        !this.$v.currentProcessingBasicData.nmProject.minLength && errors.push("O nome da pasta precisa ter no minimo 4 caracteres")
        !this.$v.currentProcessingBasicData.nmProject.maxLength && errors.push("O nome da pasta pode ter no máximo 60 caracteres")
        return errors
      },
      abProcessingTypeErrors() {
        const errors = []
        // if (!this.$v.currentProcessingBasicData.abProcessingType.$dirty) return errors
        // !this.$v.currentProcessingBasicData.abProcessingType.required && errors.push("Esse campo é obrigatório")
        return errors
      },
      inputDisabled() {
        if (this._processingIsReadOnly)
          return true
        return (!this.editMode && this._processingIsCreated) || (!this.editMode && this._processingIsCreating)
      },
      processingTypeDisabled() {
        if (this._processingIsReadOnly)
          return true
        if (!this._processingIsProcessingTypeEditable)
          return true
        return (!this.editMode && this._processingIsCreated) || (!this.editMode && this._processingIsCreating)
      },
      projectSelectionIsNone() {
        if (!this.projectSelectionState)
          return false
        return isEqual(this.projectSelectionState, PROJECT_SELECTIONS_STATES.NONE)
      },
      projectSelectionIsExisting() {
        if (!this.projectSelectionState)
          return false
        return isEqual(this.projectSelectionState, PROJECT_SELECTIONS_STATES.EXISTING)
      },
      projectSelectionIsNew() {
        if (!this.projectSelectionState)
          return false
        return isEqual(this.projectSelectionState, PROJECT_SELECTIONS_STATES.NEW_PROJECT)
      },
      mustShowEditButtons() {
        return this._processingIsBasicEditable && !this._processingIsReadOnly
      },
      processingTypeIsFP() {
        return isEqual(this.currentProcessingBasicData.abProcessingType, PROCESSING_TYPES.FULL_PROCESSING)
      },
      droneImageryIcon() {
        const SVGIcon = require("../../../assets/processings/drone-imagery.svg?inline")
        return SVGIcon.default
      },
      orthomosaicIcon() {
        const SVGIcon = require("../../../assets/processings/orthomosaic.svg?inline")
        return SVGIcon.default
      },
      ...mapGetters({
        _idProcessing: GET_ID_PROCESSING,
        _projectList: GET_PROJECT_LIST,
        _processingData: GET_PROCESSING_DATA,
        _processingIsReadOnly: GET_PROCESSING_IS_READ_ONLY,
        _processingIsCreated: GET_PROCESSING_IS_CREATED,
        _processingIsCreating: GET_PROCESSING_IS_CREATING,
        _processingIsBasicEditable: GET_PROCESSING_IS_BASIC_EDITABLE,
        _processingIsProcessingTypeEditable: GET_PROCESSING_IS_PROCESSING_TYPE_EDITABLE,
      }),
    },
    created() {
      ProcessingStepperEventBus.$on("step-change", this.onStepEnter)
    },
  }
</script>

<style scoped lang="scss">
  .actions {
    .v-btn {
      margin: 0 5px;
    }
  }
</style>
